// extracted by mini-css-extract-plugin
export default {"container":"search_decision_watcher-module__container--2_I4t"};